import React, {useState, useEffect} from "react";
import {Routes, Route, useNavigate, Link} from 'react-router-dom';
import moment from 'moment';
import {  Table, Select, DatePicker, Spin, Input,Progress,Empty, Tag, Skeleton,Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell} from 'recharts';

import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';
import Spinner from '../../components/spinner'

const { Option } = Select;

const Revenue = () => {

  var today = new Date();
  var local_month = JSON.parse(localStorage.getItem('month'));
  if(local_month){
   var mm = local_month
  }else{
      var mm = String(today.getMonth() + 1).padStart(2, '0')
  }

  var yyyy = today.getFullYear()
  yyyy = yyyy.toString()

  var local_city = JSON.parse(localStorage.getItem('cityId'))
  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }

  var local_game_type = JSON.parse(localStorage.getItem('gameType'))
  if(!local_game_type){
    local_game_type = 8
  }

  const [loading, setLoading] = useState(true)
  const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
  const [cityId, setCityId] = useState(local_city)
  const [venuelist, setVenuelist] = useState([])
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [month, setMonth] = useState(mm)
  const [year, setYear] = useState(yyyy)
  const [gameType, setGameType] = useState(local_game_type)
  const [revenueData, setRevenueData] = useState([])
  const [graphData, setGraphData] = useState({})
  const [progressBarData, setProgressBarData] = useState([])
  const [graphLoading, setGraphLoading] = useState(false)
  const [totalRevenue, setTotalRevenue] = useState('')

  useEffect(() => {
    localStorage.setItem('month', JSON.stringify(month));
    localStorage.setItem('year', JSON.stringify(year));
    localStorage.setItem('selectedVenueId',JSON.stringify(selectedVenueId))
    localStorage.setItem('cityId',JSON.stringify(cityId))
    localStorage.setItem('gameType',JSON.stringify(gameType))
  }, [month,year,selectedVenueId,cityId,gameType]);

  useEffect(() => {
     getVenues()
  }, []); 

  useEffect(() => {
    if(cityId !== ''){
      setLoading(true)
      getRevenueDetails()
      getRevenueGraph()
    }    
  }, [month,year,selectedVenueId,cityId,gameType]); 

  useEffect(() => {
    if(cities.length){
      getVenuesInCity()
    }
  }, [cities,cityId]);

  const handleCityChange = (value) => {
    if (value.length > 0) {
      const last_selected = value[value.length - 1]
      if(last_selected == 'All'){
        setCityId(['All']);
      }
      else{
        const filtered = value.filter(v => v !== 'All');
        setCityId(filtered)
      }
    }
    else {
      setCityId(['All']);
    }
  };

  const getVenuesInCity =() =>{
    if(cities[0] && !cityId){
      setCityId([cities[0].id])
    }

    let filteredVenues;

    if (cityId === 'All' || (Array.isArray(cityId) && cityId.includes('All')) ) {
      filteredVenues = venues;
    } else {
      filteredVenues = Array.isArray(cityId) ? venues.filter(item => cityId.includes(item.city)) : venues ;
    }

    setVenuelist(filteredVenues);
    const venueExists = filteredVenues.some(item => item.id === selectedVenueId);
    if (!venueExists) {
      setSelectedVenueId('All');
    }
  }

  const getVenues = async () => {
    await getData('/business/get_venues_for_buddies/')
    .then(response =>{
      setVenues(response.result)
      setCities(response.cities)
    })
    .catch(error => {
      console.log(error.message);
    });
  }

  const onChangeYear = (date, dateString) => {
    setYear(dateString);
  };

  const getRevenueDetails = () => {
    getData(`/business/get_revenue_overview/?month=${month}&year=${year}&venue_id=${selectedVenueId}&city_id=${cityId}`)
    .then(response =>{
      setRevenueData(response.result)
      setProgressBarData(response.progress_bar_data)
      setTotalRevenue(response.total_revenue)      
      setLoading(false)
    })
    .catch(error => {
      alert(error.message);
    });
  }

  const getRevenueGraph = () => {
    setGraphLoading(true)
    getData(`/business/get_revenue_graph/?month=${month}&year=${year}&venue_id=${selectedVenueId}&city_id=${cityId}&game_type_id=All`)
    .then(response =>{
      setGraphData(response.result) 
      setGraphLoading(false);
    })
    .catch(error => {
      alert(error.message);
    });
  }

  const formatIndianCurrency = (value) => {
    return Number(value).toLocaleString('en-IN')
  };

  const renderRevenueCustomer = (data,page,venue_id,type) => {
    return(
      page != null ?
        <Link to={`/revenue/${venue_id}/${page}`} className='venueTitle'>
          <div style={{fontWeight: 'bold' }}>{formatIndianCurrency(data.revenue)}</div>
          <Styled.RevenueCol>
            <div style={{color:'grey'}}>{data.customers}</div>
            <ArrowRightOutlined />
          </Styled.RevenueCol>
        </Link>
      :
        <div>
          <div style={{fontWeight: !type && 'bold' }}>{formatIndianCurrency(data.revenue)}</div>
          <div style={{color:'grey'}}>{data.customers}</div>
        </div>
    )
  }

  const renderHeader = (title,type) => {
    return(
      <div style={{ textAlign: 'center', fontWeight: type ? 'normal' :'bold' }}>{title}</div>
    )
  }  
    
  // const levelNames = revenueData[0]?.academy?.data?.map(item => item.name) || [];

  const allLevels = revenueData[0]?.academy?.data?.map(item => item.name) || [];

  // avoid those with zero entries as sum
  const levelNames = allLevels.filter(level =>
    revenueData.some(venue =>
      venue.academy?.data?.some(item => item.name === level && item.customers > 0)
    )
  );

  const academyColumn = {
    title: renderHeader('Academy'),
    align: 'center',
    children: [
      // Spread the mapped array to flatten it
      ...levelNames.map(level => ({
        title: renderHeader(level,'normal'),
        width: 110,
        dataIndex: ['academy', 'data'],
        align: 'right',
        render: (data = [], record) => {
          const item = data.find(d => d.name === level);
          if (!item) return null;

          return renderRevenueCustomer(item,null,null,'normal');
        },
      })),

      {
        title: renderHeader('Total'),
        dataIndex: 'academy',
        width: 110,
        align: 'right',
        render: (value, record) => renderRevenueCustomer(value, 'academy', record.venue.venue_id),
      },
    ],
  };

  const columns = [
    {
      title: renderHeader('Venue'),
      dataIndex: 'venue',
      width: 300,
      render: (value) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {/*<Link to={`/revenueList/${value.venue_id}`} className="venueTitle">*/}
              {value.name}
            {/*</Link>*/}
            {!value.is_active && (
              <Tag color="red" style={{ margin: 0 }}>
                Inactive
              </Tag>
            )}
          </div>
        );
      }
    },
    {
      title: renderHeader('Total'),
      dataIndex: 'total',
      render: (value) => renderRevenueCustomer(value),
      align: 'right',
      width: 100,
    },
    academyColumn,
    {
      title: renderHeader('Adults'),
      dataIndex: 'adults',
      render: (value, record) => renderRevenueCustomer(value, 'adults', record.venue.venue_id),
      align: 'right',
      width: 110,
    },
    {
      title: renderHeader('Court Booking'),
      dataIndex: 'court_booking',
      render: (value, record) => renderRevenueCustomer(value, 'courtbooking', record.venue.venue_id),
      align: 'right',
      width: 110,
    },
    {
      title: renderHeader('Others'),
      dataIndex: 'others',
      render: (value, record) => renderRevenueCustomer(value, 'others', record.venue.venue_id),
      align: 'right',
      width: 110,
    },
    {
      title:'',
      width:10
    }
  ]

  const [totals, setTotals] = useState({
    total: 0,
    adults: 0,
    court_booking: 0,
    others: 0,
    academy: {}
  });

  useEffect(() => {
    const calcTotals = {
      total: 0,
      adults: 0,
      court_booking: 0,
      others: 0,
      academy: {}
    };

    revenueData.forEach(({ total, adults, court_booking, others, academy }) => {
      calcTotals.total += total?.revenue || 0;
      calcTotals.adults += adults?.revenue || 0;
      calcTotals.court_booking += court_booking?.revenue || 0;
      calcTotals.others += others?.revenue || 0;

      // Academy level totals
      academy?.data?.forEach((level) => {
        calcTotals.academy[level.name] =
          (calcTotals.academy[level.name] || 0) + (level.revenue || 0);
      });

      // Academy total
      calcTotals.academy.total =
        (calcTotals.academy.total || 0) + (academy?.revenue || 0);
    });

    setTotals(calcTotals);
  }, [revenueData]);



  return (
    <Styled.MainContainer>

      <Styled.TopDiv>    
        <Styled.SelectorContainer>
          {cities.length > 1 &&         
            <Styled.Selector>
              <span className='indicatorText'>City</span>
              <Select
                mode="multiple"
                className = 'mainSelector'
                style={{width: 150}}
                showSearch = {true}
                placeholder="Search to Select"
                optionFilterProp="children"
                filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                onChange={handleCityChange}
                value = {cityId}
                bordered={false}
              >
                <Option value="All" name="All"> All </Option>
                {
                  cities.map(item=>(
                    <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                  ))
                }
              </Select>
            </Styled.Selector>
          }
          {venuelist && venuelist.length > 0 &&
            <Styled.Selector>
              <span className='indicatorText'>Venue</span>
              <Select
                className = 'mainSelector'
                style={{width: 300}}
                showSearch = {true}
                placeholder="Search to Select"
                optionFilterProp="children"
                filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                onChange={setSelectedVenueId}
                value = {selectedVenueId}
                bordered={false}
              >
                <Option value="All" name="All"> All </Option>
                {venuelist.map(item=>(
                  <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                  ))
                }
              </Select>
            </Styled.Selector>
          }
        </Styled.SelectorContainer>

        <div style={{display: 'flex'}}>
          <Styled.Selector>
            <span className='indicatorText'>Month</span>
            <Select
                className = 'mainSelector'
                style={{width: 150}}
                onChange={setMonth}
                value = {month}
                bordered={false}
              >
                <Option value="12"> December </Option>
                <Option value="11"> November </Option>
                <Option value="10"> October </Option>
                <Option value="09"> September </Option>
                <Option value="08"> August </Option>
                <Option value="07"> July </Option>
                <Option value="06"> June </Option>
                <Option value="05"> May </Option>
                <Option value="04"> April </Option>
                <Option value="03"> March </Option>
                <Option value="02"> February </Option>
                <Option value="01"> January </Option>
              </Select>
          </Styled.Selector>

          <Styled.Selector>
            <span className='indicatorText'>Year</span>
            <div className = 'mainSelector' style={{width: 100}}>
              <DatePicker defaultValue={moment(year, 'YYYY')}  onChange = {onChangeYear}  bordered={false}  picker="year" />
            </div>
          </Styled.Selector>
        </div>
      </Styled.TopDiv>

      <Styled.Header>          
        <span> Revenue Overview</span>
      </Styled.Header>
      
      <Styled.GraphContainer>
        <Styled.GraphDiv>
          <Styled.GraphDivLabelDiv>
            <Styled.LabelHeading> Revenue - Analysis </Styled.LabelHeading>          
          </Styled.GraphDivLabelDiv>

          {graphLoading ?
            <div style={{ height: '30vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
              <Spin />
            </div>
          :
            <ResponsiveContainer width="100%" height="80%">
              <LineChart width={500} height={300} data={graphData} margin={{ top: 5, right: 10, left: 20, bottom: 5 }}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis 
                    dataKey="month" 
                    tickFormatter={(value) => moment(value, "MMMM YYYY").format("MMM")}
                  />
                  <YAxis tickFormatter={formatIndianCurrency} />
                  <Tooltip formatter={(v, n) => [formatIndianCurrency(v), n]} />
                  <Legend />
                  <Line type="monotone" dataKey="total_revenue" stroke="#1e7c0a" name="Total Revenue"/>
                  <Line type="monotone" dataKey="academy" stroke="#c48e1a" name="Academy"/>                
                  <Line type="monotone" dataKey="adults" stroke="#4345ab" name="Adults"/>
                  <Line type="monotone" dataKey="court booking" stroke="#5676f5" name="Court Booking"/>
                  <Line type="monotone" dataKey="others" stroke="#470053" name="Others"/>
                </LineChart>
            </ResponsiveContainer>
          }
        </Styled.GraphDiv>
        
        <span></span>
        
        <Styled.GraphDiv>
          <Styled.GraphDivLabelDiv>
            <Styled.LabelHeading> Revenue Split </Styled.LabelHeading>
          </Styled.GraphDivLabelDiv>

          {loading ?
            <div style={{ height: '30vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
              <Spin />
            </div>
          :
            <div>
              {totalRevenue > 0 ?
                <Styled.PieDiv>  
                  <div style={{position: 'relative'}}>
                    <PieChart width={200} height={200}>
                      <Pie
                        data={progressBarData}
                        innerRadius={60}
                        // outerRadius={80}
                        fill="#8884d8"
                        // paddingAngle={5}
                        dataKey="amount"
                      >
                        { progressBarData.map((entry, index) => (
                          <Cell key={`cell-${entry}`} fill={entry.color} />
                        ))}
                      </Pie>
                    </PieChart>
                    <Styled.TotalAmount> {totalRevenue.toLocaleString('en-IN')} </Styled.TotalAmount>
                  </div>    
                  <Styled.PieDivInfo>
                    {
                      progressBarData.map((item,index)=>(
                        <Styled.InfoRow>
                          <Styled.InfoColor style={{backgroundColor: `${item.color}`}} />
                          <Styled.InfoLabel> {item.name} - {item.amount.toLocaleString('en-IN')}</Styled.InfoLabel>
                        </Styled.InfoRow>
                      ))
                    }  
                  </Styled.PieDivInfo>
                </Styled.PieDiv>
              :
                <Empty style={{marginTop: '10%'}} description = {<span style={{color: 'grey', fontSize: 'small'}}> data not available </span>} />
              }
            </div>
          }
        </Styled.GraphDiv>
      </Styled.GraphContainer>
      
      {loading ?
        <Skeleton active paragraph={{ rows: 7 }} title={false} />
      :
        <div>
          {/*{
            revenueData &&
            <Typography.Text type="primary" style={{ fontSize: 12}}>
              * In the table, the larger numbers show the <b>revenue</b> amount, while the smaller numbers below them represent the number of <b>customers</b>.
            </Typography.Text>
          }*/}
          <Table
            className="revenue-table table_container"
            rowKey="id"
            columns={columns}
            dataSource={revenueData}
            pagination={false}
            scroll={{ x: 'max-content' }}
            summary={() => {
              const footerValues = [
                { key: 'label', value: <b>Total</b>, align: 'Left', isLabel: true },
                { key: 'total', value: totals.total, align: 'right' },
                ...levelNames.map(level => ({
                  key: level,
                  value: totals.academy[level],
                  align: 'right'
                })),
                { key: 'academyTotal', value: totals.academy.total, align: 'right' },
                { key: 'adults', value: totals.adults, align: 'right' },
                { key: 'court_booking', value: totals.court_booking, align: 'right' },
                { key: 'others', value: totals.others, align: 'right' },
              ];

              return (
                revenueData?.length > 0 &&
                <Table.Summary.Row>
                  {footerValues.map((item, idx) => (
                    <Table.Summary.Cell key={item.key} index={idx} align={item.align || 'left'}>
                      {item.isLabel ? item.value : renderRevenueCustomer({ revenue: item.value })}
                    </Table.Summary.Cell>
                  ))}
                </Table.Summary.Row>
              );
            }}
          />
        </div>
      }

    </Styled.MainContainer>
  );
}

export default Revenue;